import { PERMISSION_DENIED_MESSAGE, usePermissions } from "@/composables/usePermissions.ts";
import authStore from "@/store/auth.js";

function restoreOriginalTitle(el) {
  if (!el._vCanTitleOwned) {
    return;
  }

  if (el._vCanOriginalTitle) {
    el.setAttribute("title", el._vCanOriginalTitle);
  } else {
    el.removeAttribute("title");
  }

  el._vCanTitleOwned = false;
  el._vCanOriginalTitle = null;
}

function applyDeniedTitle(el, blocker) {
  if (!el._vCanTitleOwned) {
    el._vCanOriginalTitle = el.getAttribute("title") || "";
    el._vCanTitleOwned = true;
  }

  el.setAttribute("title", PERMISSION_DENIED_MESSAGE);
  blocker.setAttribute("title", PERMISSION_DENIED_MESSAGE);
  blocker.setAttribute("aria-label", PERMISSION_DENIED_MESSAGE);
}

function applyPermissionState(el, hasPermission) {
  if (hasPermission) {
    if (el._vCanDisabledByDirective) {
      el.removeAttribute("disabled");
      el.disabled = false;
      el._vCanDisabledByDirective = false;
    }
    el.style.cssText = "";
    el.classList.remove("v-can-disabled");
    el.removeAttribute("aria-disabled");
    restoreOriginalTitle(el);

    if (el._vCanBlocker) {
      el._vCanBlocker.remove();
      el._vCanBlocker = null;
    }

    if (el._vCanClickHandler) {
      el.removeEventListener("click", el._vCanClickHandler, true);
      el.removeEventListener("mousedown", el._vCanClickHandler, true);
      el.removeEventListener("mouseup", el._vCanClickHandler, true);
      el.removeEventListener("keydown", el._vCanClickHandler, true);
      el._vCanClickHandler = null;
    }
  } else {
    // Não usa disabled nativo: no Chrome, botão disabled não recebe hover
    // (nem nos filhos), então o tooltip não apareceria.
    if (el._vCanDisabledByDirective) {
      el.removeAttribute("disabled");
      el.disabled = false;
      el._vCanDisabledByDirective = false;
    }
    el.style.opacity = "0.5";
    el.classList.add("v-can-disabled");
    el.setAttribute("aria-disabled", "true");

    if (!el._vCanBlocker) {
      const blocker = document.createElement("div");
      blocker.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999999;
        cursor: not-allowed;
        pointer-events: auto;
      `;

      if (getComputedStyle(el).position === "static") {
        el.style.position = "relative";
      }

      el.appendChild(blocker);
      el._vCanBlocker = blocker;
    }

    applyDeniedTitle(el, el._vCanBlocker);

    if (!el._vCanClickHandler) {
      el._vCanClickHandler = function (event) {
        if (event.type === "keydown" && event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      };

      el.addEventListener("click", el._vCanClickHandler, true);
      el.addEventListener("mousedown", el._vCanClickHandler, true);
      el.addEventListener("mouseup", el._vCanClickHandler, true);
      el.addEventListener("keydown", el._vCanClickHandler, true);
    }
  }
}

function resolvePermissionValue(value) {
  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }
  if (typeof value === "string" && value.trim() === "") {
    return null;
  }
  return value;
}

function syncPermissionState(el, binding) {
  const permissionValue = resolvePermissionValue(binding.value);
  const currentUser = authStore.getCurrentUser() || {};

  if (currentUser.is_admin === 1 || currentUser.is_admin === true) {
    applyPermissionState(el, true);
    return;
  }

  const { hasPermission } = usePermissions();
  applyPermissionState(el, hasPermission(permissionValue));
}

export default {
  mounted(el, binding) {
    syncPermissionState(el, binding);
  },

  updated(el, binding) {
    syncPermissionState(el, binding);
  },

  unmounted(el) {
    applyPermissionState(el, true);
  },
};
